import axios from 'axios';
import { WindConditions } from '../types';
import { attachAuthInterceptor } from './authToken';

const BASE_URL = process.env.REACT_APP_CLUBHOUSE_API_URL || 'http://localhost:5000';

const apiClient = axios.create({
  baseURL: `${BASE_URL}/api`,
});
attachAuthInterceptor(apiClient);

export const weatherApi = {
  /**
   * Current wind at the golfer's location. Call this when a round starts to warm the server-side
   * cache, then again at shot time. Pass the hole's green (targetLat/targetLng) to also get the
   * head/tail and crosswind components along the aim line. Returns null when wind is unavailable.
   */
  getWind: async (
    lat: number,
    lng: number,
    targetLat?: number,
    targetLng?: number,
  ): Promise<WindConditions | null> => {
    const params = new URLSearchParams({ lat: String(lat), lng: String(lng) });
    if (targetLat != null && targetLng != null) {
      params.append('targetLat', String(targetLat));
      params.append('targetLng', String(targetLng));
    }
    try {
      const { data } = await apiClient.get<WindConditions>(`/weather?${params.toString()}`);
      return data;
    } catch {
      return null;
    }
  },
};
